$("img.lazy").lazyload({
    effect: "fadeIn",
    threshold: 200, 
    failure_limit: 10, 
    skip_invisible: false,
    data_attribute: "original" 
}); 

document.addEventListener("DOMContentLoaded", function() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                let lazyImage = entry.target;

                if (entry.isIntersecting) {
                    // Imagen visible en la pantalla
                    lazyImage.src = lazyImage.dataset.original;
                    lazyImage.classList.add("visible");
                    lazyImage.classList.remove("not-visible");
                    lazyImageObserver.unobserve(lazyImage);
                } else {
                    // Imagen no visible en la pantalla
                    lazyImage.classList.add("not-visible");
                    lazyImage.classList.remove("visible");
                }
            });
        }, {
            // Opcional: Ajusta el margen del viewport
            rootMargin: "0px",
            threshold: 0.1
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fallback para navegadores que no soportan IntersectionObserver
        lazyImages.forEach(function(lazyImage) {
            lazyImage.src = lazyImage.dataset.original;
            lazyImage.classList.add("visible");
            lazyImage.classList.remove("not-visible");
        });
    }
});
